import { ICustomerSearch } from "../../models/customer.interface";

/**
 * Displays a list of Customer(s) for the add/edit card group form
 * 
 * @param {HTMLElement} container container for the list items
 * @param {object} data list data
 */

export const listCustCGWidget = (container: HTMLElement, data: ICustomerSearch[]) => {
  Object.values(data).map((value: ICustomerSearch) => {    
    let div = document.createElement('div');
    div.className = `list-results-widget key_${value.customerId}`;        

    let span = document.createElement('span');
    span.textContent = `${value.customerName} | ${value.partnerName}`;

    let addButton = document.createElement('a');
    addButton.className = 'aafp_btn-form btn_theme-primary get-selected-element';
    addButton.id = `aafp_add-${value.customerId}`;
    addButton.textContent = 'ADD';
    addButton.setAttribute(`data-id`, value.customerId.toString());
    addButton.setAttribute('data-name', value.customerName);
    addButton.setAttribute('data-partner', value.partnerName);

    div.appendChild(span);
    div.appendChild(addButton);

    if ( data.length > 1 ) {
      container.appendChild(div);  
    } else {
      container.prepend(div);  
    }    
  });

  data.length = 0;
}